<template>
    <img :src="src" :alt="alt" class="l2-logo-icon" :style="logoStyle" decoding="async" />
</template>

<script lang="ts" setup>
    import { mixNBatchLogoCUrl } from '@/utils/brandAssets';
    import { computed } from 'vue';

    const props = withDefaults(
        defineProps<{
            width?: string | number;
            height?: string | number;
            alt?: string;
        }>(),
        {
            width: 24,
            height: 24,
            alt: "Mix n' Batch",
        },
    );

    const src = mixNBatchLogoCUrl;

    const widthValue = computed(() => (typeof props.width === 'number' ? `${props.width}px` : props.width));
    const heightValue = computed(() => (typeof props.height === 'number' ? `${props.height}px` : props.height));

    const logoStyle = computed(() => ({
        width: widthValue.value,
        height: heightValue.value,
    }));
    const alt = computed(() => props.alt);
</script>

<style lang="scss" scoped>
    .l2-logo-icon {
        display: inline-block;
        object-fit: contain;
        transition:
            height var(--l2-transition),
            width var(--l2-transition);
    }
</style>

<style lang="scss">
    // Force small logo size in nav on mobile (unscoped to allow parent matching)
    .l2-nav__logo-icon .l2-logo-icon {
        @media (max-width: 650px) {
            height: 36px !important;
            width: auto !important;
        }
    }
</style>
